import { HStack, Text, VStack } from '@direct-frontend/components';
import { type SchemaProductMediaItem } from '@/shared/api/openApi';
import { CompanyLogo } from '@/shared/components/CompanyLogo';
import { ResponsiveImage } from '@/shared/components/ResponsiveImage';
import { formatPrice } from '@/shared/lib/formatPrice';
import { getProductImage } from '@/shared/lib/getProductImage';
import { getRequestContext } from '@/shared/lib/requestContext';
import styles from './OrderDigitalProduct.module.css';

export interface OrderProductProps {
    name: string;
    quantity: number;
    finalPrice: string;
    media?: SchemaProductMediaItem[];
}

export const OrderDigitalProduct = (props: OrderProductProps) => {
    const { name, quantity, finalPrice, media } = props;
    const {
        delivery: { disableEditOrderItems },
        company: { companyLogo },
    } = getRequestContext();

    const coverImage = media?.[0];

    return (
        <HStack gap="20" alignItems="center" className={styles.root}>
            <HStack className={styles.imageContainer} alignItems="center" justifyContent="center">
                {coverImage ? (
                    <ResponsiveImage
                        width="100%"
                        height="100%"
                        src={getProductImage(coverImage)}
                        borderRadius="8"
                        alt={name}
                    />
                ) : (
                    <CompanyLogo logo={companyLogo} position="product" alt="Сертификат" />
                )}
            </HStack>
            <div className={styles.content}>
                <VStack
                    justifyContent={disableEditOrderItems ? 'flex-start' : 'space-between'}
                    className={styles.wrapper}
                >
                    <div className={styles.contentContainer}>
                        <VStack>
                            <div className={styles.title}>
                                <Text className={styles.productName} size="mc">
                                    {name}
                                </Text>
                            </div>
                        </VStack>
                        <div className={styles.prices}>
                            <Text size="mc">{formatPrice((100 * Number(finalPrice) * quantity) / 100)}</Text>
                        </div>
                    </div>
                </VStack>
            </div>
        </HStack>
    );
};
